import { getEnv } from 'config/Config';
import { eaFetch, objToQueryString } from 'services/common/ApiUtils';

export async function getThirdpartySecurityRatingConfig(
  accountId,
  thirdpartyId,
  dispatch,
  signal
) {
  return eaFetch(
    dispatch,
    getEnv('REACT_APP_EDGE'),
    'GET',
    `account/${accountId}/thirdparties/${thirdpartyId}/security-rating/config`,
    null,
    null,
    null,
    signal
  );
}

export async function updateThirdpartySecurityRatingConfig(
  accountId,
  thirdpartyId,
  config,
  dispatch,
  signal
) {
  return eaFetch(
    dispatch,
    getEnv('REACT_APP_EDGE'),
    'PUT',
    `account/${accountId}/thirdparties/${thirdpartyId}/security-rating/config`,
    config,
    null,
    null,
    signal
  );
}

export async function getAccountCompaniesForScope(
  accountId,
  companyScope,
  dispatch,
  signal
) {
  const params = new URLSearchParams();

  companyScope.forEach(scope => params.append('companyScope', scope));

  return eaFetch(
    dispatch,
    getEnv('REACT_APP_EDGE'),
    'GET',
    `account/${accountId}/security-rating/companies?${params.toString()}`,
    null,
    null,
    null,
    signal
  );
}


export async function shareSecurityRatingCompany(
  accountId,
  sharingDto,
  dispatch,
  signal
) {

  return eaFetch(
    dispatch,
    getEnv('REACT_APP_EDGE'),
    'POST',
    `account/${accountId}/security-rating/companies/share`,
    sharingDto,
    null,
    null,
    signal
  );
}

export async function evaluateSecurityRating(
  accountId,
  thirdpartyId,
  config,
  dispatch,
  signal
) {
  return eaFetch(
    dispatch,
    getEnv('REACT_APP_EDGE'),
    'POST',
    `account/${accountId}/thirdparties/${thirdpartyId}/security-rating`,
    config,
    null,
    null,
    signal
  );
}

export async function getSecurityRatingScoreHistory(
  accountId,
  thirdpartyId,
  dispatch,
  signal
) {
  return eaFetch(
    dispatch,
    getEnv('REACT_APP_EDGE'),
    'GET',
    `account/${accountId}/thirdparties/${thirdpartyId}/security-rating/history`,
    null,
    null,
    signal
  );
}

export async function stopEvaluation(
  accountId,
  thirdpartyId,
  dispatch,
  signal
) {
  return eaFetch(
    dispatch,
    getEnv('REACT_APP_EDGE'),
    'POST',
    `account/${accountId}/thirdparties/${thirdpartyId}/security-rating/stop`,
    null,
    null,
    null,
    signal
  );
}

export async function getSecurityRatingScoresCount(accountId, securityRatingScoresFilters, dispatch, signal) {
  return eaFetch(
    dispatch,
    getEnv("REACT_APP_EDGE"),
    "GET",
    `account/${accountId}/thirdparties/risks/security-rating?${objToQueryString(securityRatingScoresFilters)}`,
    null, null, null, signal
  );
}